import Typography from '@material-ui/core/Typography';
import { useKnowledgeBuilderColors } from '../../../theme/knowledgeBuilderColors';
import { useDefinitionInterview } from './DefinitionContext';
import { InterviewChatPane } from './InterviewChatPane';
import { SectionNav } from './SectionNav';
import { SectionPreview } from './SectionPreview';
import { StructuredReviewPane } from './StructuredReviewPane';

export const DefinitionInterviewLayout = ({
  onOpenSource,
}: {
  onOpenSource(path?: string): void;
}) => {
  const colors = useKnowledgeBuilderColors();
  const { loading, isReviewSelected } = useDefinitionInterview();

  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        minHeight: 0,
        background: colors.bg.root,
      }}
    >
      <SectionNav />
      {loading ? (
        <div style={{ flex: 1, padding: 16 }}>
          <Typography style={{ fontSize: 12, color: colors.text.muted }}>
            Loading definition...
          </Typography>
        </div>
      ) : isReviewSelected ? (
        <StructuredReviewPane onOpenSource={onOpenSource} />
      ) : (
        <>
          <SectionPreview />
          <InterviewChatPane />
        </>
      )}
      <style>
        {`
          .knowledge-builder-scrollbar,
          .knowledge-builder-scrollbar * {
            scrollbar-width: thin;
            scrollbar-color: ${colors.scrollbar.thumb} ${colors.scrollbar.track};
          }
          .knowledge-builder-scrollbar::-webkit-scrollbar,
          .knowledge-builder-scrollbar *::-webkit-scrollbar {
            width: 12px;
            height: 12px;
          }
          .knowledge-builder-scrollbar::-webkit-scrollbar-track,
          .knowledge-builder-scrollbar *::-webkit-scrollbar-track {
            background: ${colors.scrollbar.track};
          }
          .knowledge-builder-scrollbar::-webkit-scrollbar-thumb,
          .knowledge-builder-scrollbar *::-webkit-scrollbar-thumb {
            background-color: ${colors.scrollbar.thumb};
            border-radius: 6px;
            border: 3px solid ${colors.scrollbar.track};
          }
          .knowledge-builder-scrollbar::-webkit-scrollbar-thumb:hover,
          .knowledge-builder-scrollbar *::-webkit-scrollbar-thumb:hover {
            background-color: ${colors.scrollbar.thumbHover};
          }
          .knowledge-builder-rounded .MuiOutlinedInput-root,
          .knowledge-builder-rounded .MuiOutlinedInput-notchedOutline {
            border-radius: 14px;
          }
          .knowledge-builder-chat-composer .MuiOutlinedInput-notchedOutline {
            border: 0;
          }
        `}
      </style>
    </div>
  );
};
